export const CAPTCHA_CHALLENGE_ENDPOINT = {
    method: 'GET',
    path: '/api/v1/auth/captcha',
};
//# sourceMappingURL=captcha.js.map